import { gql } from 'apollo-angular';

export const RemoveShareTacticDocument = gql`
  mutation removeTacticShare($shareId: Int!) {
    removeTacticShare(shareId: $shareId)
  }
`;
